const Inquiry = {
    isAuthenticated: null,
    userId: null,
    firstName: null,
    lastName: null,
    mobile: null,
    allowedExtensions: [],
    suggestedTags: [],
    allTags: [],
    isFetching: false
}

const initialState = {
    Inquiry,
}

export default initialState;
